import { Component, ViewChild, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenService } from './services/authen.service';
import { HelperService } from './services/helper.service';
import { SidebarService } from './sidebar/sidebar.service';
import { Util } from './helpers/global.util';
import { SignalRService } from './services/signalRService';

interface SnowFlakeConfig {
    depth: number;
    left: number;
    speed: number;
}




@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    @ViewChild('toast') toast;
    position = { X: 'Right' };
    title = 'app';
    isLogin: boolean = false;

    constructor(public auth: AuthenService, private sidebar: SidebarService, public helper: HelperService,
        private translate: TranslateService, private router: Router, private actRoute: ActivatedRoute,public signalRService: SignalRService) {

        translate.setDefaultLang('en');

        //console.log(actRoute.url);
        //console.log(window.location.href);


        //this.snowFlakes = [];

        //for (var i = 1; i <= 40; i++) {

        //    this.snowFlakes.push({
        //        depth: this.randRange(1, 5),
        //        left: this.randRange(0, 100),
        //        speed: this.randRange(1, 5)
        //    });

        //}



    }

    ngOnInit() {
        console.log('app init');

        this.helper.toast = this.toast;

        this.signalRService.startConnection();
        this.signalRService.addTransferTenderStateListener();

        this.auth.reLogin(() => {
            this.isLogin = true;
            this.startApp();
        });
    }

    onLoginCompleted(evt: any) {
        this.isLogin = true;
        this.startApp();
    }

    startApp() {
        setTimeout(() => {
            let path = Util.getPath(window.location.href);

            if (path == null || path == "/") {
                this.router.navigate(['/dashboard']);
                //this.router.navigate(['/tenders-all']);
            }
            //else
            //    this.router.navigate([path]);

            //get sitemap for first page
            setTimeout(() => { this.sidebar.getSiteMapByUrlNew(this.auth.GroupUserCode); }, 200);
        }, 500);
    }

    getSideBarState() {
        return this.sidebar.getSidebarState();
    }


    // ================= Snowfall code ======================

    public snowFlakes: SnowFlakeConfig[];
    private randRange(min: number, max: number): number {

        var range = (max - min);

        return (min + Math.round(Math.random() * range));


    }




}
